import { render, staticRenderFns } from "./JVxeDemo2.vue?vue&type=template&id=23e5caca&scoped=true&"
import script from "./JVxeDemo2.vue?vue&type=script&lang=js&"
export * from "./JVxeDemo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e5caca",
  null
  
)

export default component.exports